module.exports = __webpack_public_path__ + "img/NECMA.1be2ec18368c83e1cb41531a3957ec96.jpg";